export class ReceiveInformation{
    id : number;
    code : string;
    name : string;
    displayOrder : number;
    isRequiredNote : boolean;
} 